import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Root } from '../styles';
var ListInput = function (props) {
    var id = props.id, value = props.value, values = props.values, caption = props.caption, _a = props.tooltip, tooltip = _a === void 0 ? '' : _a, _b = props.size, size = _b === void 0 ? 'small' : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, onChange = props.onChange;
    var handleChange = function (e) {
        var _a;
        if (onChange) {
            var val = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            onChange(val);
        }
    };
    return (React.createElement(Root, { size: size },
        React.createElement(TextField, { id: id, select: true, value: value, label: caption, helperText: tooltip, disabled: disabled, onChange: handleChange, variant: "outlined" }, values.map(function (item, idx) { return (React.createElement(MenuItem, { key: idx.toString(), value: item.value }, item.text)); }))));
};
ListInput.defaultProps = {
    tooltip: '',
    size: 'small',
    disabled: false,
    onChange: undefined,
};
export default ListInput;
//# sourceMappingURL=ListInput.js.map